import { render, staticRenderFns } from "./RoleMsg.vue?vue&type=template&id=c746e5e0&"
import script from "./RoleMsg.vue?vue&type=script&lang=js&"
export * from "./RoleMsg.vue?vue&type=script&lang=js&"
import style0 from "./RoleMsg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports